<template>
  <div class="notice-container">
    <ul class="notice-list" v-if="noticeArr.length > 0">
      <li
        v-for="item in noticeArr.slice(0, 4)"
        :key="item.id"
        class="notice-item"
      >
        <router-link
          :to="{
            path: '/noticePage',
            query: {
              id: item.id,
              title: item.title,
              content: item.content,
              date: item.createTime,
              author: item.author,
            },
          }"
          class="notice-link"
          @click.native="handleNoticeClick(item.id)"
        >
          <div class="notice-content">
            <h3 class="title">{{ item.title }}</h3>
            <div class="meta-info">
              <span class="time">{{ formatDate(item.createTime) }}</span>
              <span class="views">
                <i class="el-icon-view"></i>
                {{ item.views || 0 }}
              </span>
            </div>
          </div>
        </router-link>
      </li>
    </ul>

    <!-- 空状态提示 -->
    <div class="notice-empty" v-else>
      <i class="el-icon-document"></i>
      <span>暂无公告信息</span>
    </div>

    <div class="more-wrapper">
      <el-link type="primary" @click="getAllNotice" class="more-link">
        查看更多公告
      </el-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "NoticeInfo",
  data() {
    return {
      noticeArr: [],
      noticeTest: [
        {
          id: 1,
          title: "系统维护通知",
          content: "将于本周六进行系统升级",
          createTime: "2023-07-20",
          author: "管理员",
          views: 128,
        },
        // 其他测试数据...
      ],
    };
  },
  created() {
    this.getNotice();
  },
  methods: {
    async getNotice() {
      try {
        const response = await axios.get(
          "http://www.wjyzlj.cn/pet/notice/page"
        );
        this.noticeArr = response.data.data.records.map((item) => ({
          ...item,
          views: item.views || 0, // 确保有阅读数字段
        }));
      } catch (err) {
        console.error("获取公告失败:", err);
        this.noticeArr = this.noticeTest;
      }
    },

    async handleNoticeClick(id) {
      try {
        // 调用接口更新阅读数
        await axios.patch(`/notice/view/${id}`);
        // 本地更新视图
        const index = this.noticeArr.findIndex((item) => item.id === id);
        if (index !== -1) {
          this.$set(this.noticeArr, index, {
            ...this.noticeArr[index],
            views: (this.noticeArr[index].views || 0) + 1,
          });
        }
      } catch (err) {
        console.error("更新阅读数失败:", err);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    },

    getAllNotice() {
      this.$router.push("/allNotice");
    },
  },
};
</script>

<style scoped>
.notice-container {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(64, 158, 255, 0.1);
  position: relative;
}

.notice-container:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(to bottom, #409eff, #64b5f6);
  border-radius: 3px 0 0 3px;
}

.notice-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}

.notice-item {
  position: relative;
  padding: 14px 16px;
  margin: 10px 0;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border-left: 3px solid transparent;
}

.notice-item:hover {
  background: #f9fbff;
  transform: translateX(8px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
  border-left: 3px solid #409eff;
}

.notice-link {
  text-decoration: none;
  color: #303133;
  display: block;
}

.notice-content {
  display: flex;
  flex-direction: column;
}

.title {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;
}

.notice-item:hover .title {
  color: #409eff;
}

.meta-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #909399;
}

.time {
  display: flex;
  align-items: center;
}

.time:before {
  content: "\e78f";
  font-family: element-icons !important;
  margin-right: 4px;
  font-size: 14px;
  color: #c0c4cc;
}

.views {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.more-wrapper {
  margin-top: 16px;
  padding-top: 15px;
  border-top: 1px dashed #ebeef5;
  text-align: center;
}

.more-link {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: rgba(64, 158, 255, 0.08);
  border-radius: 20px;
  transition: all 0.3s ease;
}

.more-link:hover {
  background: rgba(64, 158, 255, 0.15);
  transform: translateY(-2px);
}

.more-link:after {
  content: "\e6e0";
  font-family: element-icons !important;
  margin-left: 4px;
  transition: transform 0.3s;
}

.more-link:hover:after {
  transform: translateX(3px);
}

.notice-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  color: #909399;
}

.notice-empty i {
  font-size: 40px;
  margin-bottom: 16px;
  color: #dcdfe6;
}
</style>
